// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3dQd6","label":"Category_label__2P-v4","content":"Category_content__1tDqs","header":"Category_header__FRG-v","location":"Category_location__3pvZ7"};